import { Loader } from 'react-feather';
import { Btn } from '../AbstractElements';
import { hasGeneratedCertificate } from './certificateHandles';
import { toast } from 'react-toastify';

export const getCertificateColumn = ({
  onGenerate,
  onDownload,
  onDelete,
  loading,
  mainLoading,
  activeCourse,
}) => {
  const getLoadingStatus = (type, email) => ({
    isCurrent: loading[`${type}Loading`] && loading.email === email,
    isOther: loading[`${type}Loading`] && loading.email !== email,
  });

  const renderGenerateOrDownloadBtn = (_, record) => {
    if (!record) return null;
    const { email } = record;
    const alreadyGenerated = hasGeneratedCertificate(record, activeCourse?.id);
    const { isCurrent, isOther } = getLoadingStatus('generate', email);

    const btnLabel = isCurrent
      ? <Loader className="custom-spin" />
      : alreadyGenerated
        ? "Download"
        : "Generate";

    const btnColor = alreadyGenerated ? "success" : "primary";

    const handleClick = () =>
      alreadyGenerated ? onDownload(record) : onGenerate(record);

    return (
      <Btn
        attrBtn={{
          color: btnColor,
          className: "w-100 d-flex justify-content-center align-items-center",
          disabled: isCurrent || isOther || mainLoading,
          onClick: handleClick,
        }}
      >
        {btnLabel}
      </Btn>
    );
  };

  const renderDeleteBtn = (_, record) => {
    if (!record) return null;
    const { email } = record;
    const alreadyGenerated = hasGeneratedCertificate(record, activeCourse?.id);
    const { isCurrent, isOther } = getLoadingStatus('delete', email);

    const handleClick = () => {
      if (!alreadyGenerated) return toast.error("Certificate not generated yet");
      onDelete(record);
    };

    return (
      <Btn
        attrBtn={{
          color: "danger",
          className: "w-100 d-flex justify-content-center align-items-center",
          disabled: !alreadyGenerated || isCurrent || isOther || mainLoading,
          onClick: handleClick,
        }}
      >
        {isCurrent ? <Loader className="custom-spin" /> : "Delete"}
      </Btn>
    );
  };

  return [
    {
      title: "STUDENT ID",
      dataIndex: "studentId",
      fixed: "left",
      className: "text-center",
      sorter: (a, b) => a.studentId - b.studentId,
    },
    {
      title: "NAME",
      dataIndex: "fullName",
      fixed: "left",
      sorter: (a, b) => a.fullName.localeCompare(b.fullName),
    },
    {
      title: "EMAIL",
      dataIndex: "email",
      fixed: "left",
      sorter: (a, b) => a.email.localeCompare(b.email),
    },
    {
      title: "ATTENDANCE",
      dataIndex: "attendanceRatio",
      className: "text-center",
      sorter: (a, b) => b.presentClasses - a.presentClasses,
    },
    {
      title: "ACTION",
      dataIndex: "action",
      render: renderGenerateOrDownloadBtn,
    },
    {
      title: "DELETE",
      dataIndex: "action",
      render: renderDeleteBtn,
    }
  ];
};
